
import { ADD_LEAD_ITEM, DELETE_LEAD_ITEM, GET_ALL_LEAD, GET_ALL_LEAD_CATEGORY, GET_ALL_LEAD_FAILED, GET_ALL_LEAD_SUCCESS, LEAD_CATEGORY_ADD_ITEM, LEAD_CATEGORY_DELETE, LEAD_CATEGORY_UPDATE, UPDATE_LEAD_ITEM } from '../../constants/leadConstants';

const initialState = {
    leadAllData: {
        data: [],
        pagination: {
            page: 1
        }
    },
    category: {
        data: [],
        pagination: {}
    },
    isLoading: false,
    error: null
};

export default function leadDataReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ALL_LEAD:
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case GET_ALL_LEAD_SUCCESS:
            const isFirstPage = action.payload.page === 1;
            return {
                ...state,
                isLoading: false,
                leadAllData: {
                    data: isFirstPage
                        ? action.payload.data
                        : [...state.leadAllData.data, ...action.payload.data],
                    pagination: action.payload.pagination
                }
            };

        case ADD_LEAD_ITEM:
            return {
                ...state,
                isLoading: false,
                leadAllData: {
                    data: [action.payload.data, ...state.leadAllData.data],
                }
            };

        case UPDATE_LEAD_ITEM: {
            const updatedData = action.payload.data; // Assuming action.payload.data is an array of items to update
            const updatedLeadData = updatedData.map(newItem => {
                const existingItemIndex = state.leadAllData.data.findIndex(item => item.id === newItem.id);
                if (existingItemIndex !== -1) {
                    // If the item exists, return the updated item
                    return {
                        ...state.leadAllData.data[existingItemIndex],
                        ...newItem // Merge existing item with new item data
                    };
                }
                // If the item does not exist, return the new item
                return newItem;
            });

            // Create a new array that includes updated items and any existing items not in the updatedData
            const finalData = [
                ...updatedLeadData,
                ...state.leadAllData.data.filter(item => !updatedData.some(newItem => newItem.id === item.id))
            ];

            return {
                ...state,
                isLoading: false,
                leadAllData: {
                    data: finalData,
                }
            };
        }
        case GET_ALL_LEAD_CATEGORY:
            const isCatFirstPage = action.payload.page === 1;
            return {
                ...state,
                isLoading: false,
                category: {
                    data: isCatFirstPage
                        ? action.payload.data
                        : [...state.category.data, ...action.payload.data],
                    pagination: action.payload.pagination
                }
            };
        case DELETE_LEAD_ITEM:
            const itemId = action.payload.id
            return {
                ...state,
                isLoading: false,
                leadAllData: {
                    ...state.leadAllData,
                    data: state.leadAllData.data.filter(item => item.id !== itemId)
                }
            };
        case LEAD_CATEGORY_ADD_ITEM: {
            const categoryId = action.payload.catId;
            const categoryItem = action.payload.item;
            return {
                ...state,
                category: {
                    ...state.category,
                    data: state.category.data.map(item =>
                        item.id === categoryId
                            ? {
                                ...item,
                                items: item.items ?
                                    item.items.some(existingItem => existingItem.id === categoryItem.id)
                                        ? item.items
                                        : [...item.items, categoryItem]
                                    : [categoryItem],
                                itemCount: (item.items && item.items.some(existingItem => existingItem.id === categoryItem.id))
                                    ? item.itemCount
                                    : (item.itemCount || 0) + 1
                            }
                            : item
                    )
                },
                isLoading: false
            };
        }
        case LEAD_CATEGORY_DELETE: {
            const categoryId = action.payload.catId;
            return {
                ...state,
                category: {
                    ...state.category,
                    data: state.category.data.filter(item => item.id !== categoryId) // Filter out the category with the matching ID
                },
                isLoading: false
            };
        }
        case LEAD_CATEGORY_UPDATE: {
            const categoryId = action.payload.catId;
            const updatedTitle = action.payload.title;
            const updatedData = [action.payload.data];
            // console.log(updatedData)

            return {
                ...state,
                category: {
                    ...state.category,
                    data: (!Array.isArray(state.category.data) || state.category.data.length === 0)
                        ? updatedData
                        : state.category.data.map(item =>
                            item.id === categoryId ? { ...item, title: updatedTitle } : item
                        )
                },
                isLoading: false
            };
        }

        case GET_ALL_LEAD_FAILED:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };

        default:
            return state;
    }
}